module.exports = __webpack_public_path__ + "static/media/sy_dummies_ppt_pic_1.f56bcd47.png";